import { toastr } from 'react-redux-toastr';
import {
  ITINERARY_ADDITIONAL_FOOD_ENDPOINT,
  ITINERARY_FOOD_ENDPOINT,
} from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_ITINERARY_ADDITIONAL_FOODS,
  FLAG_ITINERARY_ADDITIONAL_FOOD_ACTIVITY,
  FLAG_ITINERARY_ADDITIONAL_FOODS,
  GET_ITINERARY_ADDITIONAL_FOODS,
} from '../types/itinerary/ItineraryAdditionalFood';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
} from '../../config/rest';
import {
  getItineraryForCounter,
  getListDriversForItinerary,
  getCargoItemByItinerary,
  getPassengerFlowForItinerary,
  getItineraryGeofenceAlerts,
} from '../index';
import { getTicketReassignments } from '../reservation/TicketReassignment';
import { DEFAULT_QUERY, DEFAULT_QUERY_GET_ALL } from '../../config/queries';

const flagItineraryAdditionalFoodActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_ADDITIONAL_FOOD_ACTIVITY,
    payload: flag,
  });

const postItineraryFood =
  (itineraryId, itineraryScheduleFoodRequestList = []) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryAdditionalFoodActivity(true));

      const url = `${ITINERARY_FOOD_ENDPOINT}/${itineraryId}`;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(itineraryScheduleFoodRequestList),
      });

      await isErrorResponse(response, null, dispatch);
      await response.json();

      dispatch(getItineraryForCounter(itineraryId));
      dispatch(getListDriversForItinerary({ itineraryId }));
      dispatch(getCargoItemByItinerary({ itineraryId, ...DEFAULT_QUERY }));
      dispatch(getPassengerFlowForItinerary({ itineraryId }));
      dispatch(getItineraryGeofenceAlerts(itineraryId));
      dispatch(
        getTicketReassignments({
          ...DEFAULT_QUERY_GET_ALL,
          query: [`previousItineraryId:${itineraryId}`],
        }),
      );

      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagItineraryAdditionalFoodActivity(false));
    }
  };

const postItineraryAdditionalFood =
  (
    itineraryId,
    {
      supplierId,
      documentSeries,
      documentCode,
      comment,
      itineraryAdditionalFoodTypeList,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryAdditionalFoodActivity(true));

      const payload = {
        supplierId,
        documentSeries,
        documentCode,
        comment,
        itineraryAdditionalFoodTypeList,
      };

      const url = `${ITINERARY_ADDITIONAL_FOOD_ENDPOINT}/${itineraryId}`;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);
      await response.json();

      dispatch(getItineraryForCounter(itineraryId));
      dispatch(getListDriversForItinerary({ itineraryId }));
      dispatch(getCargoItemByItinerary({ itineraryId, ...DEFAULT_QUERY }));
      dispatch(getPassengerFlowForItinerary({ itineraryId }));
      dispatch(getItineraryGeofenceAlerts(itineraryId));
      dispatch(
        getTicketReassignments({
          ...DEFAULT_QUERY_GET_ALL,
          query: [`previousItineraryId:${itineraryId}`],
        }),
      );

      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagItineraryAdditionalFoodActivity(false));
    }
  };

const flagGetItineraryAdditionalFoods = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_ADDITIONAL_FOODS,
    payload: flag,
  });

const getItineraryAdditionalFoods = (itineraryId) => async (dispatch) => {
  try {
    dispatch(flagGetItineraryAdditionalFoods(true));

    const url = `${ITINERARY_ADDITIONAL_FOOD_ENDPOINT}/${itineraryId}`;

    const response = await fetch(url, {
      ...DEFAULT_GET_CONFIG,
    });

    await isErrorResponse(response, null, dispatch);

    const itineraryAdditionalFoods = await response.json();

    dispatch({
      type: GET_ITINERARY_ADDITIONAL_FOODS,
      payload: itineraryAdditionalFoods,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGetItineraryAdditionalFoods(false));
  }
};

const clearItineraryAdditionalFoods = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_ADDITIONAL_FOODS,
  });

const deleteItineraryFood = (itineraryId, supplierId) => async (dispatch) => {
  try {
    dispatch(flagItineraryAdditionalFoodActivity(true));

    const url = `${ITINERARY_FOOD_ENDPOINT}/${itineraryId}/supplier/${supplierId}`;

    const response = await fetch(url, {
      ...DEFAULT_DELETE_CONFIG,
    });

    await isErrorResponse(response, null, dispatch);

    dispatch(getItineraryForCounter(itineraryId));
    dispatch(getListDriversForItinerary({ itineraryId }));
    dispatch(getCargoItemByItinerary({ itineraryId, ...DEFAULT_QUERY }));
    dispatch(getPassengerFlowForItinerary({ itineraryId }));
    dispatch(getItineraryGeofenceAlerts(itineraryId));
    dispatch(
      getTicketReassignments({
        ...DEFAULT_QUERY_GET_ALL,
        query: [`previousItineraryId:${itineraryId}`],
      }),
    );

    return true;
  } catch (error) {
    toastr.error('Error', error.message);
    return false;
  } finally {
    dispatch(flagItineraryAdditionalFoodActivity(false));
  }
};

const deleteItineraryAdditionalFood =
  (itineraryId, supplierId) => async (dispatch) => {
    try {
      dispatch(flagItineraryAdditionalFoodActivity(true));

      const url = `${ITINERARY_ADDITIONAL_FOOD_ENDPOINT}/${itineraryId}/supplier/${supplierId}`;

      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });

      await isErrorResponse(response, null, dispatch);

      dispatch(getItineraryForCounter(itineraryId));
      dispatch(getListDriversForItinerary({ itineraryId }));
      dispatch(getCargoItemByItinerary({ itineraryId, ...DEFAULT_QUERY }));
      dispatch(getPassengerFlowForItinerary({ itineraryId }));
      dispatch(getItineraryGeofenceAlerts(itineraryId));
      dispatch(
        getTicketReassignments({
          ...DEFAULT_QUERY_GET_ALL,
          query: [`previousItineraryId:${itineraryId}`],
        }),
      );

      return true;
    } catch (error) {
      toastr.error('Error', error.message);
      return false;
    } finally {
      dispatch(flagItineraryAdditionalFoodActivity(false));
    }
  };

export {
  postItineraryFood,
  postItineraryAdditionalFood,
  getItineraryAdditionalFoods,
  clearItineraryAdditionalFoods,
  deleteItineraryFood,
  deleteItineraryAdditionalFood,
};
